export type Theme = "light" | "dark";

const KEY = "theme";
const META: Record<Theme, string> = { light: "#f5f6f8", dark: "#111317" };

/** The theme currently applied to the document (set before paint by the inline script). */
export function getTheme(): Theme {
  return document.documentElement.getAttribute("data-theme") === "dark" ? "dark" : "light";
}

export function setTheme(theme: Theme) {
  document.documentElement.setAttribute("data-theme", theme);
  document.querySelector('meta[name="theme-color"]')?.setAttribute("content", META[theme]);
  try {
    localStorage.setItem(KEY, theme);
  } catch {
    /* private mode: the choice lasts for this page view only */
  }
}
